import { render, staticRenderFns } from "./FileInput.vue?vue&type=template&id=07f456fe&lang=pug&"
import script from "./FileInput.vue?vue&type=script&lang=ts&"
export * from "./FileInput.vue?vue&type=script&lang=ts&"
import style0 from "./FileInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports